// extracted by mini-css-extract-plugin
module.exports = {"summary-wrapper":"_3wM2F","summaryWrapper":"_3wM2F","summary-line":"_2f5DX","summaryLine":"_2f5DX"};